import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-zinc-500 text-sm">
        Caricamento...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
